import React from 'react';
import PropTypes from 'prop-types';
import ReduxModal from 'components/reduxModal';
import { Trans } from 'components';

export const MODAL_ID = 'info-modal';

const InfoModal = ({ close }) => (
  <ReduxModal
    id={MODAL_ID}
  >
    {(Modal, { extra }) => (
      <div>
        <Modal.Heading title={extra.title} />
        <Modal.Footer>
          <button type="button" onClick={close} className="full-btn has-margin-left">{extra.btnText || <Trans>OK, rozumiem</Trans>}</button>
        </Modal.Footer>
      </div>
    )}
  </ReduxModal>
);

InfoModal.propTypes = {
  close: PropTypes.func.isRequired
}

export default InfoModal;


// WEBPACK FOOTER //
// ./src/components/globalModals/InfoModal.jsx